import { PartnerResource, ResourceImageType } from '../interfaces/partnerResources.interface';
import User, { Company } from '../interfaces/users.interface';
import { USER_TYPES } from './user';

export default function canAdminCompany(user: User | undefined, company: Company) {
  if (!user) return false;
  if (user.type == USER_TYPES.TPN_ADMIN) return true;
  if (!company.employees?.length) return false;

  const companyEmployeeIds: number[] = company.employees.map((employee: User) => employee.id);

  if (!companyEmployeeIds.includes(user.id)) return false;
  const adminUser = company.admins?.find((admin: User) => admin.id == user.id);

  return adminUser != undefined;
}

export const canStartFiveThreeOneSurvey = (user: User | undefined) => {
  if (!user) return false;
  return !!user?.permissions?.includes('can_start_v5_3_1');
};

export const getResourceImageUrl = (r?: PartnerResource | null) =>
  r?.images?.find((img) => img.type === ResourceImageType.IMAGE)?.image || '';